import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "table table-hover" }
const _hoisted_9 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_10 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_11 = { class: "align-middle" }
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = { class: "input-group-append" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["disabled", "onClick"]
const _hoisted_17 = { class: "modal-footer" }
const _hoisted_18 = ["disabled"]
const _hoisted_19 = ["disabled"]

import { computed, toRef } from 'vue'

    import { copyToClipboard } from '@common/Common'

    import type { CriteriaPanelistReadModel } from '@Evaluation/CriteriaSurveys/Domain/readmodels'
    import type { CriteriaSurveyAccessLinksViewModel } from '@Evaluation/CriteriaSurveys/Components/CriteriaSurveyAccessLinks'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CriteriaSurveyAccessLinks',
  props: {
    viewModel: {}
  },
  emits: ["download-links", "show-email-sender"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived ----------------

    const opened = computed(() => vm.value.opened)
    const surveyId = computed(() => vm.value.surveyId)
    const initialized = computed(() => vm.value.data != null)

    const panelists = computed(() => vm.value.data?.Panelists ?? [])

    // ---------------- actions ----------------

    function downloadLinks()
    {
        emit('download-links', surveyId.value)
    }

    function emailOne(panelist: CriteriaPanelistReadModel)
    {
        emit('show-email-sender', surveyId.value, [panelist.ProjectUserId])
    }

    function emailAll()
    {
        emit(
            'show-email-sender',
            surveyId.value,
            panelists.value.map(p => p.ProjectUserId)
        )
    }

    function copyAccessUrlToClipboard(panelist: CriteriaPanelistReadModel)
    {
        copyToClipboard(panelist.AccessUrl)

        const originalUrl = panelist.AccessUrl
        panelist.AccessUrl = 'Copied to clipboard'

        const handle = setTimeout(() =>
        {
            panelist.AccessUrl = originalUrl
            clearTimeout(handle)
        }, 500)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "modal-title" }, "Access links", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                (!initialized.value)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Loading...", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (initialized.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("table", _hoisted_8, [
                        _cache[5] || (_cache[5] = _createElementVNode("thead", { class: "thead-light" }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("th", null, " Panelist "),
                            _createElementVNode("th", null, " Access link ")
                          ])
                        ], -1 /* CACHED */)),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(panelists.value, (p) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: p.ProjectUserId
                            }, [
                              _createElementVNode("td", null, [
                                _createElementVNode("span", null, _toDisplayString(p.Name), 1 /* TEXT */),
                                _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1 /* CACHED */)),
                                (p.HasEmail)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(p.Email), 1 /* TEXT */))
                                  : _createCommentVNode("v-if", true),
                                (!p.HasEmail)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Email not provided"))
                                  : _createCommentVNode("v-if", true)
                              ]),
                              _createElementVNode("td", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    readonly: "",
                                    "onUpdate:modelValue": ($event: any) => ((p.AccessUrl) = $event)
                                  }, null, 8 /* PROPS */, _hoisted_13), [
                                    [_vModelText, p.AccessUrl]
                                  ]),
                                  _createElementVNode("div", _hoisted_14, [
                                    _createElementVNode("button", {
                                      class: "btn btn-outline-secondary",
                                      type: "button",
                                      title: "Copy to clipboard",
                                      onClick: ($event: any) => (copyAccessUrlToClipboard(p))
                                    }, [...(_cache[3] || (_cache[3] = [
                                      _createElementVNode("i", {
                                        class: "fa fa-clipboard",
                                        "aria-hidden": "true"
                                      }, null, -1 /* CACHED */)
                                    ]))], 8 /* PROPS */, _hoisted_15),
                                    _createElementVNode("button", {
                                      class: "btn btn-outline-secondary",
                                      type: "button",
                                      title: "Send link via email",
                                      disabled: !p.HasEmail,
                                      onClick: ($event: any) => (emailOne(p))
                                    }, [...(_cache[4] || (_cache[4] = [
                                      _createElementVNode("i", { class: "fa-regular fa-envelope" }, null, -1 /* CACHED */)
                                    ]))], 8 /* PROPS */, _hoisted_16)
                                  ])
                                ])
                              ])
                            ]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  onClick: downloadLinks,
                  disabled: !initialized.value,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Download links", 8 /* PROPS */, _hoisted_18),
                _createElementVNode("button", {
                  onClick: emailAll,
                  disabled: !initialized.value,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Email all", 8 /* PROPS */, _hoisted_19)
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})